module.exports = __webpack_public_path__ + "static/media/fabro.b36b0b37.jpg";